<svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.06542 8.64377L13.198 3.54908C14.3011 2.76114 15.8334 3.54968 15.8334 4.9053L15.8334 15.0947C15.8334 16.4503 14.3011 17.2388 13.198 16.4509L6.06542 11.3562C5.13484 10.6915 5.13484 9.30847 6.06542 8.64377Z" fill="#006BFF"/>
</svg>
